import { useEffect } from "react";
import { useDeviceType } from "@/common/hooks/useDeviceType";
import { deviceTypeEnum } from "@/common/utils/device";
import { useAppStore } from "@/common/store/appStore";
import { useScrollStore } from "@/common/store/scrollStore";

export const addDeviceClass = (element: Element, device: deviceTypeEnum): void => {
  for (const key in deviceTypeEnum) {
    const deviceType = deviceTypeEnum[key as keyof typeof deviceTypeEnum];
    element.classList.toggle(deviceType, device === deviceType);
  }
};

export const useAppStyles = () => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);
  const isForceFS = useAppStore((state) => state.isForceFS);
  const scrollElement = useScrollStore((state) => state.scrollElement);

  const deviceType = useDeviceType();

  useEffect(() => {
    if (!scrollElement) {
      return;
    }

    scrollElement.classList.toggle("fullScreen", isFullScreen);
    scrollElement.classList.toggle("expFullScreen", isForceFS);
    addDeviceClass(scrollElement, deviceType);
  }, [isFullScreen, isForceFS, deviceType, scrollElement]);
};
